import { setCode } from "./code";
import { hideSpinner } from "./loading";
import { showConfirmPayment } from "./payment";
import { i18n } from "./texts";
import { startTimer } from "./timer";

type Tags = "TIMER" | "QRCODE" | "BOX_INFO";

interface FormElement {
  type: "text" | "clipboard" | "image";
  content?: string;
  src?: string;
  pre_label?: string;
  post_label?: string;
  tags: Tags[];
}

interface IQrForm {
  form_identifier: string;
  elements: FormElement[];
}

const qrTarget = document.getElementById("qr-container");

const setQr = (e: any) => {
  if (qrTarget) {
    qrTarget.style.backgroundImage = "url('" + e.src + "')";
  }

  console.log("showing qr code");
};

export const setupQrForm = (form: IQrForm, locale: string) => {
  showConfirmPayment();
  //Find the info element (pertaining to igaming merchants accepted bank accounts)
  const info = form.elements.find((e) => e.type == "text" && e.tags.includes("BOX_INFO"));
  if (info) {
    const defaultMsg = i18n[locale]["configuredAccounts"];
    document.getElementById("bank-account-info-text-container")!.innerText = info?.content ?? defaultMsg;
    document.getElementById("bank-account-info")?.classList.replace("--hidden", "--visible");
  }

  // Find the timer element
  const timer = form.elements.find((e) => e.type == "text" && e.tags.includes("TIMER"));
  if (timer) {
    startTimer(timer.content || "");
  }

  // Find the code element
  const code = form.elements.find((e) => e.type == "clipboard");
  if (code) {
    setCode(code.content || "", code.pre_label || "", code.post_label || "");
  }

  // Find the QR element
  const qr = form.elements.find((e) => e.type == "image" && e.tags.includes("QRCODE"));
  if (qr) {
    setQr(qr);
  }

  hideSpinner();
};
